import React, { useState, useEffect } from 'react';
import lodash from "lodash";
import { useParams } from 'react-router-dom';

import axios from "../../../axios";
import { detectIconById } from "../../../common/enum";
import './detail.scss';

import { renderTitleGame, renderBadge, renderScoreMatch, renderTableScoreRound } from "./components/GameCard";
import { title, tableTitle2, tableTitleStartingPitcher, tableTitleStartingBatter } from "./constant";
import Loading from "../../../components/loading";
import { Button, Modal, Card, Collapse, Row, Col, Tag } from "antd";
import 'antd/dist/antd.css';

const { Panel } = Collapse;

export const LiveDetail = (props) => {
    const { game_id } = useParams()
    const [loading, setLoading] = useState(null)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [gameData, setGameData] = useState({})
    const [gameDataDetail, setGameDataDetail] = useState({})
    const [gamesCore, setGamesCore] = useState({})
    const getDataApi = () => {
        return axios.get(`api/lives/games/${game_id}`);
    }

    const getDataDetail = () => {
        return axios.get(`api/lives/games/${game_id}/details`);
    }

    const getDataCore = () => {
        return axios.get(`api/lives/games/${game_id}/score_plays`)
    }

    const renderAwayHomeruns = (data) => {
        return (
            <table className='table-batteries-homeruns'>
                <tr>
                    <td style={{ backgroundColor: '#F7FAFC', textAlign: 'center', fontWeight: 'bold', width: 120 }}>本塁打</td>
                    <td style={{ backgroundColor: '#F7FAFC', textAlign: 'center' }}></td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>{data.away.team.team_name_s}</td>
                    <td>{
                        data.away.homeruns.length > 0 && data.away.homeruns.map((item, index) => item ? item.player.player_name_s + item.number + '号' + item.type_name + '(' + item.inning + '回表)' + (data.away.homeruns[index + 1] ? ', ' : '') : ' ')
                    }</td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>{data.home.team.team_name_s}</td>
                    <td>{
                        data.home.homeruns.length > 0 && data.home.homeruns.map((item, index) => item ? item.player.player_name_s + item.number + '号' + item.type_name + '(' + item.inning + '回裏)' + (data.home.homeruns[index + 1] ? ', ' : '') : ' ')
                    }</td>
                </tr>
            </table>
        )
    }

    const renderAwayBatteries = (data) => {
        return (
            <table className='table-batteries-homeruns'>
                <tr>
                    <td style={{ backgroundColor: '#F7FAFC', textAlign: 'center', fontWeight: 'bold', width: 120 }}>バッテリー</td>
                    <td style={{ backgroundColor: '#F7FAFC', textAlign: 'center' }}></td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>{data.away.team.team_name_s}</td>
                    <td>
                        {
                            data.away.batteries.pitchers.length > 0 && data.away.batteries.pitchers.map((item, index) => item ? item.player_name_s + (data.away.batteries.pitchers[index + 1] ? ', ' : '') : ' ')
                        } - {
                            data.away.batteries.catchers.length > 0 && data.away.batteries.catchers.map((item, index) => item ? item.player_name_s + (data.away.batteries.catchers[index + 1] ? ', ' : '') : ' ')
                        }
                    </td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>{data.home.team.team_name_s}</td>
                    <td>
                        {
                            data.home.batteries.pitchers.length > 0 && data.home.batteries.pitchers.map((item, index) => item ? item.player_name_s + (data.home.batteries.pitchers[index + 1] ? ', ' : '') : ' ')
                        } - {
                            data.home.batteries.catchers.length > 0 && data.home.batteries.catchers.map((item, index) => item ? item.player_name_s + (data.home.batteries.catchers[index + 1] ? ', ' : '') : ' ')
                        }
                    </td>
                </tr>
            </table>
        )
    }

    const renderHomeBatteries = (data) => {
        return (
            <table className='table-batteries-homeruns'>
                <tr>
                    <td style={{ backgroundColor: '#F7FAFC', textAlign: 'center', fontWeight: 'bold', width: 120 }}>盗塁</td>
                    <td style={{ backgroundColor: '#F7FAFC', textAlign: 'center' }}></td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>{data.away.team.team_name_s}</td>
                    <td>{
                        data.away.steals.length > 0 && data.away.steals.map((item, index) => item ? item.player.player_name_s + '(' + item.inning + '回表)' + (data.away.steals[index + 1] ? ', ' : '') : ' ')
                    }</td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center' }}>{data.home.team.team_name_s}</td>
                    <td>{
                        data.home.steals.length > 0 && data.home.steals.map((item, index) => item ? item.player.player_name_s + '(' + item.inning + '回裏)' + (data.home.steals[index + 1] ? ', ' : '') : ' ')
                    }</td>
                </tr>
            </table>
        )
    }

    const renderResponsiablePitcher = (data) => {
        return data.responsible_pitchers && data.responsible_pitchers.length > 0 && (
            <table className='table-responsiable-pitcher' style={{ border: 'hidden' }}>
                <tr style={{ display: 'flex' }}>
                    <td style={{ backgroundColor: '#F7FAFC', textAlign: 'center', fontWeight: 'bold', minWidth: '120px', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>責任投手</td>
                    <table className='table-style'>
                        {
                            data.responsible_pitchers.map((item, idx) => {
                                return (<tr key={idx}>
                                    <td>
                                        {item.w_l_sv_type_name}
                                    </td>
                                </tr>)
                            })
                        }
                    </table>
                    <table className='table-style-item'>
                        {
                            data.responsible_pitchers.map((item, idx) =>
                                <tr key={idx}>
                                    <td>{item.player_name_s}{item.stats && <span>&nbsp;({item.stats.w}勝{item.stats.l}敗{item.stats.sv}S)</span>}</td>
                                </tr>
                            )
                        }
                    </table>
                </tr>
            </table>
        )
    }

    const renderTableRecord = (header, data, key) => {
        return (
            <table className='table-record'>
                <tr>
                    {
                        header.map(item => <th><p className={item == '選手名' ? 'active-round' : ''}>{item}</p></th>)
                    }
                </tr>
                {
                    data[key].batters.map((item, index) => {
                        return (
                            <tr className='row' style={index % 2 !== 0 ? { backgroundColor: '#F7F7F7' } : {}}>
                                <td style={{ width: '50px' }}>{item.order.batting_order}</td>
                                <td>
                                    {item.order.positions.map((position, idx) => {
                                        return <span className='rectangle'
                                            key={idx + 'result-game-outting'}
                                            style={{ border: !position.is_starting ? 'none' : '', background: !position.is_starting ? 'none' : '' }}>
                                            {!position.is_starting ? ' ' : ''}{position.position_name_s}
                                        </span>
                                    })}
                                </td>
                                <td style={{ 'text-align': 'left', cursor: 'pointer' }} className='active-round text-line-1' onClick={() => props.history.push(window.open(`/player/${item.order.player.id}`, '_blank'))} >{item.is_current && <div></div>}{item.order.player.player_name}</td>
                                <td>{item.result.avg}</td>
                                <td>{item.result.ab}</td>
                                <td>{item.result.h}</td>
                                <td>{item.result.rbi}</td>
                                <td>{item.result.so}</td>
                                <td>{item.result.homeruns && item.result.homeruns.map(hrnum => <p className='round-gray'>{hrnum}</p>)}</td>
                                {renderInningBadge('1', item)}
                                {renderInningBadge('2', item)}
                                {renderInningBadge('3', item)}
                                {renderInningBadge('4', item)}
                                {renderInningBadge('5', item)}
                                {renderInningBadge('6', item)}
                                {renderInningBadge('7', item)}
                                {renderInningBadge('8', item)}
                                {renderInningBadge('9', item)}
                                {renderInningBadge('10', item)}
                                {renderInningBadge('11', item)}
                                {renderInningBadge('12', item)}
                            </tr>
                        )
                    })
                }
                <tr className='total'>
                    <td></td>
                    <td></td>
                    <td>合計</td>
                    <td>{data[key].total.avg}</td>
                    <td>{data[key].total.ab}</td>
                    <td>{data[key].total.h}</td>
                    <td>{data[key].total.rbi}</td>
                    <td>{data[key].total.so}</td>
                    <td>{data[key].total.homerun}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                {key === 'away' && data.away.batters[0] && (
                    <>
                        <tr className='class-top-img' style={{ borderTop: '1px solid #cccccc', height: '50px', textAlign: 'center' }}>
                            <td><img src={detectIconById(data.away.batters[0].order.player.team.id)} alt="" style={{ width: '35px', height: '35px' }} /></td>
                            <td colspan="2" style={{ textAlign: 'left' }}><span>{data.away.batters[0].order.player.team.team_name_s}</span></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='text-line2'></td>
                            <td className='text'><span>{data.result.top.total}</span></td>
                            {data.innings.map(item => {
                                return (
                                    <td className='item-number'><span>{item.top.is_x ? item.top.r + 'x' : item.top.r}</span></td>
                                )
                            })}
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </>
                )}
                {key === 'home' && data.home.batters[0] && (
                    <>
                        <tr className='class-bottom-img'>
                            <td style={{ padding: '5px' }}><img className='img' src={detectIconById(data.home.batters[0].order.player.team.id)} alt="" style={{ width: '35px', height: '35px' }} /></td>
                            <td colspan="2" style={{ textAlign: 'left' }}><span>{data.home.batters[0].order.player.team.team_name_s}</span></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='text'><span>{data.result.bottom.total}</span></td>
                            {data.innings.map(item => {
                                if (item.bottom && item.bottom.is_x) {
                                    return (
                                        <td style={{ textAlign: 'center' }}><span>{item.bottom.r + 'x'}</span>
                                        </td>
                                    );
                                }
                                else if (item.bottom) {
                                    return (
                                        <td style={{ textAlign: 'center' }}><span>{item.bottom.r}</span>
                                        </td>
                                    )
                                }
                                else {
                                    return (
                                        <td style={{ textAlign: 'center' }}><span></span>
                                        </td>
                                    )
                                }
                            })}
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </>
                )}
            </table>
        )
    }
    const renderInningBadge = (key, data) => {
        const greenStyle = { background: '#13BF69', fontWeight: 'bold', color: '#fff' };
        const blueStyle = { background: '#0577fa', fontWeight: 'bold', color: '#fff' };
        const violetStyle = { background: 'blue', fontWeight: 'bold', color: '#fff' };
        if (data.innings[key]) {
            return (
                <td style={{ padding: 'unset' }}>{
                    data.innings[key].map(item => <div className={data.innings[key].length > 1 ? 'inning-badge' : 'inning-badge height-full'} style={item.is_hr ? violetStyle : item.is_rbi ? blueStyle : item.is_h ? greenStyle : {}}>{item.result_name}</div>)
                }</td>
            )
        }
        return <td></td>
    }
    const renderBattingRecordList = (data) => {
        const inningRow = data.innings.map(item => item.inning);
        const header = lodash.concat(['打順', '位置', '選手名', '打率', '打数', '安打', '打点', '三振', '本塁打'], inningRow);

        return (
            <div className='batting-record-wrap'>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <h3>打撃成績一覧</h3>
                    </Col>
                    <Col span={12} style={{
                        padding: '10px', display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center'
                    }}>
                        <Tag style={{ backgroundColor: '#13bf69', width: '30px', height: '20px' }} />
                        <span>安打</span>
                        <Tag style={{ backgroundColor: '#0577fa', width: '30px', height: '20px', marginLeft: '10px' }} />
                        <span>打点</span>
                        <Tag style={{ backgroundColor: 'blue', width: '30px', height: '20px', marginLeft: '10px' }} />
                        <span>本塁打</span>
                    </Col>
                </Row>
                {renderTableRecord(header, data, 'away')}
                {renderTableRecord(header, data, 'home')}
            </div>
        )
    }
    const renderRowTableBunch = (i, item) => {
        return (
            <tr key={i}>
                <td className={'table-item'} style={{ width: 80, height: 30 }}></td>
                <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}>{item.player.player_name}</td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.era') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.ip') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.np') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.bf') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.h') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.hr') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.so') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.bb') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.hbp') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.r') || 0}
                </td>
                <td className={'table-item'} style={{ width: 100 }}>
                    {lodash.get(item, 'result.er') || 0}
                </td>
            </tr>
        )
    }
    async function displayDataApi() {
        try {
            const [game, gameDetail, Core] = await Promise.all([getDataApi(2020080402), getDataDetail(2020080402), getDataCore(2020080402)]);
            setLoading(false)
            setGameData(game.data);
            setGamesCore(Core.data);
            setGameDataDetail(gameDetail.data);
        } catch (e) {
            console.log(e.response);
        }
    }

    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        setLoading(true);
        displayDataApi();
        const interval = setInterval(() => {
            displayDataApi();
        }, 30000);
        return () => clearInterval(interval);
    }, [])
    return (
        <div className="wrap_live_detail">
            <div className="title-live-detail">
                <img alt='back' src='./../img/ic_arrow_left.svg' onClick={() => props.history.push('/live')} style={{ cursor: 'pointer' }} />
                <h3 style={{ marginLeft: 20 }}>試合詳細</h3>
            </div>
            {
                !loading ?
                    !lodash.isEmpty(gameData) && !lodash.isEmpty(gameDataDetail) && (
                        <>
                            <div className='game-detail-title'>
                                <div className='game-detail-title-content'>
                                    <div className='d-flex' style={{ display: 'flex' }}>
                                        {renderTitleGame(gameData)}
                                        {renderBadge(gameData)}
                                    </div>
                                    <span className='update-title'><img src="/img/update_24px.svg" alt="" width={24} />30秒ごとに更新</span>
                                </div>
                            </div>
                            <div className='card-game-detail'>
                                <div className="left-content">
                                    {renderScoreMatch(gameData, props.history)}
                                    {renderTableScoreRound(gameData, props.history)}
                                    {renderAwayHomeruns(gameData)}
                                </div>
                                <div className="right-content">
                                    {renderResponsiablePitcher(gameData)}
                                    {renderAwayBatteries(gameData)}
                                    {renderHomeBatteries(gameData)}
                                </div>
                            </div>
                            {renderBattingRecordList(gameDataDetail)}
                            <div className={'top-title'}>投手成績一覧</div>
                            <div className={'table-border'}>
                                <div className={'table-name'}>{lodash.get(gameDataDetail, 'away.pitchers[0]') &&
                                    gameDataDetail.away.pitchers[0].player.team.team_name
                                }</div>
                                <table>

                                    <thead>
                                        <tr>
                                            {title.map((item, idx) => {
                                                return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                    {idx === 0 ? item.title = '' : item.title}
                                                </div></th>
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            lodash.get(gameDataDetail, 'away.pitchers') &&
                                            gameDataDetail.away.pitchers.map((item, i) =>
                                                renderRowTableBunch(i, item)
                                            )
                                        }

                                    </tbody>
                                </table>
                            </div>
                            <div className={'table-border'}>
                                <div className={'table-name'}>{lodash.get(gameDataDetail, 'home.pitchers[0]') &&
                                    gameDataDetail.home.pitchers[0].player.team.team_name
                                }</div>
                                <table>

                                    <thead>
                                        <tr>
                                            {title.map((item, idx) => {
                                                return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                    {idx === 0 ? item.title = '' : item.title}
                                                </div></th>
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            lodash.get(gameDataDetail, 'home.pitchers') &&
                                            gameDataDetail.home.pitchers.map((item, i) =>
                                                renderRowTableBunch(i, item)
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className={'top-title'}>スターティングメンバー</div>
                            <div className={'dual-table'}>
                                <div className={'left-table'}>
                                    <div className={'table-name'}>{lodash.get(gameDataDetail, 'away.starting.pitchers[0].player.team.team_name') ?
                                        gameDataDetail.away.starting.pitchers[0].player.team.team_name : ''}</div>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableTitleStartingPitcher.map((item, idx) => {
                                                    return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                        {item.title}
                                                    </div></th>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                lodash.get(gameDataDetail, 'away.starting.pitchers') && gameDataDetail.away.starting.pitchers.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className={'table-item'} style={{ textAlign: 'center', width: 40 }}>先発</td>
                                                            <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}><div style={{ display: "flex" }}><div className={'rounded-letter'}>投</div>{item.player.player_name}</div></td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.lr_name}</td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.era}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableTitleStartingBatter.map((item, idx) => {
                                                    return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                        {item.title}
                                                    </div></th>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                lodash.get(gameDataDetail, 'away.starting.batters') && gameDataDetail.away.starting.batters.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className={'table-item'} style={{ textAlign: 'center', width: 40 }}>{item.batting_order}</td>
                                                            <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}><div style={{ display: "flex" }}><div className={'rounded-letter'}>{item.position_name_s}</div>{item.player.player_name}</div></td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.lr_name}</td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.avg}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className={'right-table'}>
                                    <div className={'table-name'}>{lodash.get(gameDataDetail, 'home.starting.pitchers[0].player.team.team_name') ?
                                        gameDataDetail.home.starting.pitchers[0].player.team.team_name : ''}</div>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableTitleStartingPitcher.map((item, idx) => {
                                                    return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                        {item.title}
                                                    </div></th>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                lodash.get(gameDataDetail, 'home.starting.pitchers') && gameDataDetail.home.starting.pitchers.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className={'table-item'} style={{ textAlign: 'center', width: 40 }}>先発</td>
                                                            <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}><div style={{ display: "flex" }}><div className={'rounded-letter'}>投</div>{item.player.player_name}</div></td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.lr_name}</td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.era}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableTitleStartingBatter.map((item, idx) => {
                                                    return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                        {item.title}
                                                    </div></th>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                lodash.get(gameDataDetail, 'home.starting.batters') && gameDataDetail.home.starting.batters.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className={'table-item'} style={{ textAlign: 'center', width: 40 }}>{item.batting_order}</td>
                                                            <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}><div style={{ display: "flex" }}><div className={'rounded-letter'}>{item.position_name_s}</div>{item.player.player_name}</div></td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.lr_name}</td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.avg}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className={'top-title'}>ベンチ入りメンバー</div>
                            <div className={'dual-table'}>
                                <div className={'left-table'}>
                                    <div className={'table-name'}>{lodash.get(gameDataDetail, 'away.bench.pitchers[0].player.team.team_name') ?
                                        gameDataDetail.away.bench.pitchers[0].player.team.team_name : ''}</div>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableTitle2.map((item, idx) => {
                                                    return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                        {idx === 0 ? item.title = '' : item.title}
                                                    </div></th>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                lodash.get(gameDataDetail, 'away.bench.pitchers') && gameDataDetail.away.bench.pitchers.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className={'table-item'} style={{ width: 1 }}></td>
                                                            <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}><div style={{ display: "flex" }}><div className={'rounded-letter'}>投</div>{item.player.player_name}</div></td>
                                                            <td className={'table-item'} style={{ width: 100 }}>
                                                                {item.lr_name}
                                                            </td>
                                                            <td className={'table-item'} style={{ width: 100 }}>
                                                                {item.era}
                                                            </td>
                                                        </tr>
                                                    )
                                                })

                                            }
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableTitle2.map((item, idx) => {
                                                    return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                        {item.code === 1 ? item.title1 : item.title}
                                                    </div></th>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                lodash.get(gameDataDetail, 'away.bench.batters') && gameDataDetail.away.bench.batters.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className={'table-item'} style={{ width: 1 }}></td>
                                                            <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}><div style={{ display: "flex" }}><div className={'rounded-letter'}>{item.position_name_s}</div>{item.player.player_name}</div></td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.lr_name}</td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.avg} </td>

                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className={'right-table'}>
                                    <div className={'table-name'}>{lodash.get(gameDataDetail, 'home.bench.pitchers[0].player.team.team_name') ?
                                        gameDataDetail.home.bench.pitchers[0].player.team.team_name : ''}</div>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableTitle2.map((item, idx) => {
                                                    return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                        {idx === 0 ? item.title = '' : item.title}
                                                    </div></th>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                lodash.get(gameDataDetail, 'home.bench.pitchers') && gameDataDetail.home.bench.pitchers.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className={'table-item'} style={{ width: 1 }}></td>
                                                            <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}><div style={{ display: "flex" }}><div className={'rounded-letter'}>投</div>{item.player.player_name}</div></td>
                                                            <td className={'table-item'} style={{ width: 100 }}>
                                                                {item.lr_name}
                                                            </td>
                                                            <td className={'table-item'} style={{ width: 100 }}>
                                                                {item.era}
                                                            </td>
                                                        </tr>
                                                    )
                                                })

                                            }
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableTitle2.map((item, idx) => {
                                                    return <th className={'header-title'} style={idx === 1 ? { textAlign: 'start' } : { textAlign: 'center' }}><div className={'title-head'}>
                                                        {item.code === 1 ? item.title1 : item.title}
                                                    </div></th>
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                lodash.get(gameDataDetail, 'home.bench.batters') && gameDataDetail.home.bench.batters.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td className={'table-item'} style={{ width: 1 }}></td>
                                                            <td className={'table-item'} style={{ textAlign: 'start', paddingLeft: 17, width: 172 }}><div style={{ display: "flex" }}><div className={'rounded-letter'}>{item.position_name_s}</div>{item.player.player_name}</div></td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.lr_name}</td>
                                                            <td className={'table-item'} style={{ width: 100 }}>{item.avg} </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            <div className='button'>
                                <br></br>
                                <Button className='button-live' type="primary" onClick={showModal}>
                                    得点経過
                                </Button>
                                <Modal title="得点経過" visible={isModalVisible} footer={null}>
                                    {gamesCore.map((value, index) => (
                                        <>
                                            <Card className='card' title={`${value.inning}回${value.top_bottom_name}${value.team_name_s}`}>
                                                <Collapse defaultActiveKey={[index]} expandIconPosition='right'>
                                                    {value.data.map((datas, index) => (
                                                        <Panel header={<><span className='inning'>{datas.pa_of_inning}</span>
                                                            {datas.batting_order}番:
                                                            <span style={{ fontWeight: 700, margin: 5 }}>{datas.player.player_name}</span>
                                                            {datas.display_status}
                                                        </>} key={index}>
                                                            {datas.plays.map((value, index) => (
                                                                <div className='text-number'>
                                                                    <p className={index === 0 ? 'np_of_2' : 'np_of'
                                                                    }>
                                                                        &nbsp;
                                                                    </p>
                                                                    <span>{value.text}</span>
                                                                </div>
                                                            ))}
                                                        </Panel>
                                                    ))}
                                                </Collapse>
                                            </Card>
                                        </>
                                    ))}
                                    <div className='button-cancel'>
                                        <Button type="ghost" className='cancel' onClick={handleCancel}>閉じる</Button>
                                    </div>
                                </Modal>
                            </div>
                        </>
                    ) : (<Loading show={loading} />)
            }
        </div>
    );
}
